<template>
    <div class="fidelity-container" :class="{'androidMode': isAndroidMode()}">
        <div class="bg" v-if="!success">
            <img :src="logo" >
            <h2 v-text="buildTextTitle()"></h2>
            <span class="qst">{{ getString('voce_possui') }} {{ formatMoney(this.balanceValue) }} {{ getString('utiliza_desconto') }}</span>
            <div class="input-container" :class="hasError ? 'error-shake' : ''">
                <div id="discount-fidelity" ref="discountFidelityDiv" class="div-input-android"></div>
                <span v-if="hasError" class="error-message"> {{ errorMessage }}</span>
            </div>
            <div class="buttons-container">
                <DefaultButton v-for="(btn, key) in buttons" :key="key"
                    :text="btn.text" @defaultBtnClick="btn.action()" class="buttons">
                </DefaultButton>
            </div>
        </div>
        <div class="bg" v-else>
            <img :src="logo" >
            <h2>{{ getString('desconto_aplicado') }}</h2>
            <div class="resume-container" v-if="success">
                <div>{{ getString('valor_compra') }}</div>
                <div class="value"> {{ beforeTotalValue() }}</div>
                <div>{{ getString('desconto') }}</div>
                <div class="value">{{ getApplyedDiscount() }}</div>
                <div>{{ getString('total_dois_pontos_simples') }} </div>
                <div class="value">{{ getTotal() }}</div>
            </div>
            <div class="buttons-container">
                <DefaultButton
                    :text="buttons[0].text" @defaultBtnClick="buttons[0].action()" class="buttons">
                </DefaultButton>
            </div>
        </div>

        <AndroidKeyboard v-if="!success" id="android-keyboard"
            :inputElement="inputElement"
            :layout="layout"
            :bigNumeric="true"
            :onInput="applyMoneyRules">
        </AndroidKeyboard>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton.vue'
import LocaleController from '@/assets/controllers/LocaleController'
import CartController from '@/assets/controllers/CartController'
import CashbackCampaingController from '@/assets/controllers/CashbackCampaingController'
import Loader from '@/components/Loader'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'

export default {
    name: 'FidelityModal',
    components: {
        DefaultButton,
        AndroidKeyboard,
        Loader
    },
    data () {
        return {
            logo: '',
            hasError: false,
            balanceValue: 0,
            discount: '0,00',
            maxDiscount: null,
            totalValue: CartController.getTotalPriceAsFloat(),
            consumerData: {},
            campaingEnabled: null,
            layout: keyboardLayout.MONEY_NUMERIC_NO_CONFIRM,
            inputElement: null,
            buttons: [
                {
                    text: this.getString('agora_nao'),
                    action: this.continue
                },
                {
                    text: this.getString('aplicar_desconto'),
                    action: this.applyDiscount
                }
            ],
            success: false,
            errorMessage: ''
        }
    },
    created () {
        // CashbackCampaingController.clearData()
        this.maxDiscount = CashbackCampaingController.getCashbackBonusValue().maxValue.toFixed(2)
        this.balanceValue = CashbackCampaingController.getCashbackBonusValue().available.toFixed(2)
        this.discount = this.maxDiscount
        let data = CashbackCampaingController.getConsumerData()
        this.campaingEnabled = data.campaignEnabled
        this.consumerData = data.consumerData
        this.logo = this.campaingEnabled === 1 ? require('../../static/icons/crmBonus.png') : (Util.getConfigImage('logo') || require('../../static/client/header.png'))
        let input = document.getElementById('discount-fidelity')
        if (input) { input.focus() }
    },
    mounted () {
        this.inputElement = this.$refs.discountFidelityDiv
        this.inputElement.innerText = ('' + this.discount).replace('.', ',')
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        formatMoney: function (value) {
            return Util.formatMoney(value)
        },
        continue: function () {
            CashbackCampaingController.setProcessedStatus(true)
            this.$emit('closeFidelitymodal')
        },
        applyDiscount: async function () {
            this.discount = this.$refs.discountFidelityDiv.innerText || '0'
            this.discount = Util.formatMoney(parseFloat(this.discount.replace(',', '.')))

            this.buttons[1].text = this.getString('aguarde')
            this.validDiscount()

            if (this.hasError) {
                this.showError()
                this.buttons[1].text = this.getString('aplicar_desconto')
                return false
            }

            let discount = this.sanitizeNumber(this.discount)
            let result = await CashbackCampaingController.setDiscount(discount)
            if (result.error) {
                this.success = false
                this.hasError = true
                this.errorMessage = `Não foi possivel aplicar o desconto: ${result.message}`
                this.showError()
                this.buttons[1].text = this.getString('aplicar_desconto')
                return false
            }
            this.buttons[0].text = this.getString('continuar')
            this.inputElement.innerText = ''
            this.success = true
        },
        validDiscount: function () {
            let discount = this.sanitizeNumber(this.discount)
            if (!discount || discount <= 0) {
                this.hasError = true
                this.errorMessage = this.getString('menor_zero')
                this.showError()
                return false
            }
            if (discount > this.totalValue || discount > this.maxDiscount) {
                this.hasError = true
                this.errorMessage = this.getString('erro_valor_compra')
                this.showError()
                return false
            }

            if (discount > this.balanceValue) {
                this.hasError = true
                this.errorMessage = this.getString('erro_valor_desconto')
                this.showError()
                return false
            }

            if (!this.hasError) {
                this.errorMessage = ''
            }
        },
        showError: function () {
            const sf = this
            sf.hasError = true
            setTimeout(() => {
                sf.hasError = false
            }, 2000)
        },
        sanitizeNumber: function (value) {
            value = value.replace('R$', '').replace(',', '').replace('.', '').trim()
            return parseFloat(value) / 100
        },
        beforeTotalValue: function () {
            return this.formatMoney(this.totalValue)
        },
        getTotal: function () {
            let discount = CashbackCampaingController.getDiscountApplied().value
            return this.formatMoney(this.totalValue - discount)
        },
        getApplyedDiscount: function () {
            let discount = CashbackCampaingController.getDiscountApplied().value
            return this.formatMoney(discount)
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        buildTextTitle: function () {
            let text = ''
            if (this.consumerData && this.consumerData.consumerName && this.consumerData.consumerName !== 'NOVO CONSUMIDOR') {
                text = `Bem vindo de volta ${this.getFirstName(this.consumerData.consumerName)}!`
            } else {
                text = `Boas Notícias!`
            }
            return text
        },
        getFirstName: function (name) {
            let firstName = name.split(' ')
            if (firstName[0]) {
                firstName = firstName[0].toLowerCase()
                return firstName.charAt(0).toUpperCase() + firstName.slice(1)
            }
            return name
        },
        applyMoneyRules: function (input) {
            if (!input) return ''

            if (input[0] === ',') input = '0' + input
            input = this.notAllowDuplicatedComma(input)
            input = this.notAllowExcedentDecimalCases(input)

            return input
        },
        notAllowDuplicatedComma: function (input) {
            let firstComma = input.indexOf(',')
            let lastComma = input.lastIndexOf(',')
            if (firstComma !== -1 && firstComma !== lastComma) {
                input = input.slice(0, -1)
            }
            return input
        },
        notAllowExcedentDecimalCases: function (input) {
            let array = input.split(',')
            if (array.length > 1 && array[1].length > 2) {
                input = input.slice(0, -1)
            }
            return input
        }
    }
}
</script>

 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped lang='less'>
     @import (reference) url("../assets/common.less");
     .fidelity-container{
         position: fixed;
         left: 0;
         right: 0;
         bottom: 0;
         top: 0;
         margin: auto 150px;
         background: @white;
         border-radius: 25px;
         z-index: 2;
         box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
         padding-bottom: 10px;
         padding-top: 10px;
         min-height: min-content;
         max-height: max-content;
     .bg{
         position: relative;
         background: white;
         padding: 30px 30px 0 30px;
         border-radius: 15px;
         opacity: 1;
         img {
             display: block;
             margin: auto;
             max-width: 500px;
             height: auto;
             object-fit: contain;
             padding: 20px;
         }
         h2, span, img {
             display: block;
             font-size: 2rem;
             margin: auto;
             text-align: center;
             opacity: 1;
         }
         h2, span.qst {
             margin: 15px 0;
             font-weight: bold;
         }
         .input-container {
             margin: 40px 45px;
             text-align: center;
             &.error-shake {
                .div-input-android {
                        border: 2px solid rgba(255, 0, 0);
                        margin: 50px 0 10px 0;
                 }
                 animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                 transform: translate3d(0, 0, 0);
             }
            .div-input-android {
                position: relative;
                margin: 50px 0;
                display: block;
                font-size: 4rem;
                height: 85px;
                background-color: white;
                color: black;
                border: 2px solid black;
                border-radius: 20px;
                padding: 0 20px;
            }
         }

         .resume-container {
                display: grid;
                grid-template-columns: 70% 30%;
                margin: 30px 70px;
                div {
                    font-size: 1.8rem;
                    padding-left: 30px;
                    padding-bottom: 10px;
                }
            }
         .buttons-container {
             margin: 50px 0;
             display: -webkit-box;
             display: -ms-flexbox;
             display: flex;
             flex-direction: row;
             flex-wrap: nowrap;
             align-content: center;
             justify-content: space-around;
             align-items: center;
             button:first-of-type{
                 background: white;
                 border: solid 1px black;
                 color: black;
             }
         }
     }
     &.androidMode {
        margin: auto 80px;
        .bg {
            img {
             width: 300px;
             height: auto;
             object-fit: contain;
         }
        }
     }
     #keyboard {
         .keyboard;
         width: inherit;
         max-width: 930px;
         top: inherit;
         position: unset;
         bottom: 0;
     }

    #android-keyboard {
        margin: 0 30px 30px 30px;
    }

     @keyframes shake {
         10%,
         90% {
             transform: translate3d(-1px, 0, 0);
         }

         20%,
         80% {
             transform: translate3d(2px, 0, 0);
         }

         30%,
         50%,
         70% {
             transform: translate3d(-4px, 0, 0);
         }

         40%,
         60% {
             transform: translate3d(4px, 0, 0);
         }
     }
 }

@media (max-width: 698px) { // Gertec SK210
    .fidelity-container{
        margin: auto 50px !important;
        border-radius: 10px;
        .bg{
            padding: 0 30px 0 30px;
            img {
                width: 130px !important;
                padding: 5px;
            }
            h2, img {
                font-size: 18px;
            }
            span {
                font-size: 14px;
            }
            .input-container {
                margin: 0 10px;
                .div-input-android {
                    font-size: 25px;
                    height: 35px;
                    padding: 0 10px;
                    border-radius: 5px;
                    margin: 10px 0;
                }
                &.error-shake {
                    .div-input-android {
                        margin: 10px 0 10px 0;
                    }
             }
            }
            .buttons-container {
                margin: 20px 0 5px 0;
                button {
                    margin: 0 5px;
                }
            }
            .resume-container {
                display: grid;
                grid-template-columns: 80% 20%;
                margin: 30px 20px;
                div {
                    font-size: 18px;
                    padding-left: 0;
                    padding-bottom: 10px;
                }
            }
        }
        #android-keyboard {
            margin: 0;
            .small-screen-keyboard;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) { //@tablet
    .fidelity-container{
        margin: auto 80px;
        border-radius: 10px;
        .bg{
            padding: 0 30px 0 30px;
            img {
                // max-width: 300px;
                height: 160px;
                width: auto;
                padding: 30px;
            }
            h2, img {
                font-size: 25px;
            }
            span {
                font-size: 20px;
            }
            .input-container {
                margin: 0 10px;
                .div-input-android {
                    font-size: 35px;
                    height: 45px;
                    padding: 0 10px;
                    border-radius: 10px;
                    margin: 10px 0;
                }
                &.error-shake {
                    .div-input-android {
                        margin: 10px 0 10px 0;
                    }
             }
            }
            .buttons-container {
                margin: 20px 0 5px 0;
                button {
                    margin: 0 5px;
                    min-width: 220px;
                    height: 70px;
                    margin: 10px 0;
                }
            }
            .resume-container {
                display: grid;
                grid-template-columns: 80% 20%;
                margin: 30px 20px;
                div {
                    font-size: 22px;
                    padding-left: 0;
                    padding-bottom: 10px;
                }
            }
        }
        #android-keyboard {
            margin: 10px 20px;
            .small-screen-keyboard;
        }
    }
}
 </style>



// WEBPACK FOOTER //
// src/components/FidelityModal.vue